import { toast } from "react-toastify";
import { Firestore } from "../lib/firebase";
import "react-toastify/dist/ReactToastify.css";


toast.configure({
  autoClose: 2000,
  draggable: false
});
const TYPE_OF_GARMENTS_TABLE_NAME = "garmentTypes";


export function getTypeofGarments() {
  return Firestore.collection(TYPE_OF_GARMENTS_TABLE_NAME)
    // .where("market", "==", country)
    .get()
    .then((results) => results.docs.map((garmentTypes) => garmentTypes.data()))
    .catch((error) => {
      throw new Error(error);
    });
}
export async function getTypeofGarmentsById(id) {
  try {
    return Firestore.collection(TYPE_OF_GARMENTS_TABLE_NAME)
    .doc(id)
    .get()
    .then((docRef) => { return docRef.data() })
      .catch((error) => { 
        throw new Error(error);
    })
  
} catch (error) {
  throw error;
}
}

export function deleteTypeofGarmentById(id, setData,isDeleting,setIsDeleting) {

  if (isDeleting) {
    return;
  }

  setIsDeleting(true);

  const docRef = Firestore.collection(TYPE_OF_GARMENTS_TABLE_NAME).doc(id);

  docRef.delete()
    .then(() => {
      setData(prevData => prevData.filter(item => item.id !== id));
      toast.success("Garment type deleted successfully!", {
        position: toast.POSITION.TOP_LEFT
      });
    })
    .catch((error) => {
      console.error("Error removing document: ", error);
    })
    .finally(() => {
      setIsDeleting(false);
    });
}

export const create = async (payload,setData,inputText,setInputText,id,setIsLoading,isLoading) => {
  try {
    if (isLoading) {
      return;
    }
    setIsLoading(true); 
    const loadingFunc = () => {
      setIsLoading(false)
    }
      // Check if the garment value already exists in Firestore
      const existingDoc = await Firestore.collection(TYPE_OF_GARMENTS_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();
      
    if (!existingDoc.empty) {
      toast.error("Garment type already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      setTimeout(loadingFunc, 2000);

    
      return;
    }

      await Firestore.collection(TYPE_OF_GARMENTS_TABLE_NAME).doc(payload.id)
      .set(payload)
      .then(() => {
        setData(prevData => [...prevData, { id: id, value: inputText, label: inputText }]);
        setInputText("");
        toast.success("Garment type created successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
        setTimeout(loadingFunc, 2000);

    })
    
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};
export const update = async (payload,history) => {
  try {
    // Check if the garment value already exists in Firestore
    const existingDoc = await Firestore.collection(TYPE_OF_GARMENTS_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();

    if (!existingDoc.empty) {
      toast.error("Garment type already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      return;
    }

    await Firestore.collection(TYPE_OF_GARMENTS_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        history.goBack()
        toast.success("Garment type updated successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};